// extracted by mini-css-extract-plugin
export default {"LoadingIndicator":"X8H8dttzBmpxL1DxBv_2"};